import UiuxData from './UiuxData'
import React from 'react';
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const ListUiUx = () => {

    const { ref, inView } = useInView();
    const animation3up = useAnimation();


    useEffect(() => {
        console.log("useeffect hook", inView);
        if (inView) {

            animation3up.start({
                y: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });
        }
        if (!inView) {

            animation3up.start({
                y: 60,
                opacity: 0,
            });
        }
    }, [inView]);

    const listItemsUi = UiuxData.map(({ id, src, title, description }) =>
        <li key={id} className='lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 py-8 border-b-[1px] border-b-line/70 lg:py-20'>
            <motion.div animate={animation3up} className="lg:col-start-1 lg:col-end-3 lg:pr-8">
                <h2 className='text-[1.8em] font-[700] leading-[1.8]'>{title}</h2>
                <p className='mb-4 mt-3'>{description}</p>
                <a href="#" className='underline text-center hover:-translate-y-1 transition-all mb-8 block w-fit mx-auto lg:mx-0 lg:mb-0'>Details</a>
            </motion.div>
            <img src={src} alt="rizal-port" className="lg:col-start-3 lg:col-end-5 w-full hover:scale-[1.4] transition-all" />
        </li>
    )

    return (
        <ul ref={ref} className='lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4 '>
            {listItemsUi}
        </ul>
    );
};

export default ListUiUx;
